export const SET_WORKSTATIONWITHSCISSORSTATUSINFO = 'SET_WORKSTATIONWITHSCISSORSTATUSINFO';
export const SET_BREAKDOWNDETECTEDDIALOGOPEN = 'SET_BREAKDOWNDETECTEDDIALOGOPEN';
export const SET_UPDATEDWORKSTATIONID = 'SET_UPDATEDWORKSTATIONID';


